<template>
    <div class="row mx-auto">
        <div class="col-lg-3 col-xs-12 mx-2 mb-3">
            <div class="dashboard-card mb-3 p-3 d-flex">
                <div class="img-circle mx-2"><img src="../../assets/image/man.png"/></div>
                <div class="mx-2 my-auto">
                    <p class="sub-heading">{{userDetails.name}}</p>
                    <p class="fade-text">{{userDetails.designation.replaceAll('_',' ')}}</p>
                </div>
            </div>
            <div class="dashboard-card p-2">
                <div class="p-2">
                  <div class="d-flex justify-content-between">
                    <p class="sub-heading mb-1">Personal Info</p>
                    <font-awesome-icon icon="fa-solid fa-user-pen" @click="toggleEditUserDetailsModal"/>
                    </div>
                    <hr class="my-0 mb-2">
                    <p class="normal-text">Email</p>
                    <p class="fade-text mb-2">{{userDetails.email}}</p>

                    <p class="normal-text">Mobile No</p>
                    <p class="fade-text mb-2">{{userDetails.mobileNumber}}</p>

                    <p class="normal-text">Designation</p>
                    <p class="fade-text mb-2">{{userDetails.designation.replaceAll('_',' ')}}</p>

                    <p class="normal-text">Location</p>
                    <p class="fade-text mb-2">{{userDetails.location}}</p>
                </div>
            </div>
        </div>

        <div class="col-lg-8 col-xs-12 mx-2">
          <div class="dashboard-card p-3 mx-2">
            <div class="worksheet my-2">
                <p class="heading mb-1">Your Trainings</p>
                <div class="content-card p-3 d-flex mb-1">

                <div class="px-1" v-for="(worksheet, index) in worksheets" :key="index" @click="handleClick(worksheet.id)">
                 <Card  class="module-card">
            <div class="d-flex justify-content-between">
              <div class="p-3">
                <p class="worksheet-title" :title="worksheet.name">{{worksheet.name}}</p>
                <p class="reporter-label">Reporter:</p>
                <p class="reporter-title" @mouseover="toggle()" @mouseleave="toggle()">Ashok 
                  <!-- <span class="rounded-circle p-1">+2</span> -->
                </p>
                <!-- <transition name="bounce"><div v-if="tran">hello</div></transition> -->
              </div>
              <div class="chart-area">
                <ApexChart :options="chartOptions" :series="calculateProgress(worksheet.completedTasks,worksheet.totalNoOfTasks)" />
              </div>
            </div>
            <div class="start-date-badge my-2">
              <Badge
                v-if="worksheet.startedDate"
                :label="`Start Date: ` + formatDate(worksheet.startedDate)"
                class="badge-rounded badge-rounded-grey-outline ms-2"
              />
               <Badge
                v-else
                label="NOT YET STARTED"
                class="badge-neon badge-neon-warning-outline ms-2"
              />
              
            </div>
          </Card>
                </div>

                </div>
            </div>

            <div class="heat-map my-2">
                <p class="heading mb-1">Your Progress</p>
                <div class="content-card p-3 mb-1">
            <calendar-heatmap
              :values="heatmapdata"
              :max="10"
              :end-date="getTodayDate()"
              :range-color="['#E8e8e8', '#90e893', '#3ace3e', '#4fce52', '#09a20d', '#057d08']"
              tooltip-unit="Completions"
              :vertical="false"
            />
                </div>
            </div>

            <div class="activity my-2">
                <p class="heading mb-1">Activity</p>
                <div class="content-card p-3 mb-1">

                    <div class="dashboard-card row p-2 m-2" v-for="(task, index) in history" :key="index">
                        <div class="col-lg-6 col-sm-6 col-xs-12 normal-text">{{ shrinkText(task.taskName) }}</div>
                        <div class="col-lg-3 col-sm-3 col-xs-6 fade-text">{{ formatDate(task.completedDate) }}</div>
                        <div class="col-lg-3 col-sm-3 col-xs-6 float-center"><Badge :label="task.status" 
              :class="[
                      task.status === 'COMPLETED'
                        ? 'badge-neon badge-neon-success-outline'
                        : '',
                      task.status === 'RESUBMITTED'
                        ? 'badge-neon badge-neon-warning-outline'
                        : ''
                    ]"/></div>
                    </div>

                </div>
            </div>
        </div>
        </div>
        <Modal @close="toggleEditUserDetailsModal" :modalActive="editUserModal">
          <h4>Edit Personal Info</h4>
          <hr class="my-0 mb-1">
          <Input 
          label="Name *"
          v-model="module.name"
          class="mt-3"
          />
          <Input 
          label="mobileNumber *"
          v-model="module.mobileNumber"
           class="mt-3"
          />
          <Input 
          label="Designation *"
          v-model="module.designation"
           class="mt-3"
          />
          <Input 
          label="Location *"
          v-model="module.location"
           class="mt-3"
          />
          <Button label="save" class="qb-btn qb-btn-primary-md mt-3"></Button>
        </Modal>
    </div>
</template>

<script>
import Card from "../../components/CardComponent.vue"
import Badge from "../../components/BadgeComponent.vue"
import Modal from "../../components/ModalComponent.vue"
import Input from "../../components/TextFieldComponent.vue"
import Button from "../../components/ButtonComponent.vue"
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapUserActions, mapGetters } =
  createNamespacedHelpers("User");
const { mapGetters: mapAuthGetters } = createNamespacedHelpers("Auth");
export default {
    name:"AssigneeDashBoard",
    data() {
    return {
      module:{
        name:"",
        email:"",
        designation:"",
        mobileNumber:"",
        location:""
      },
      editUserModal:false,
      completed: 0,
      total: 0,
      chartOptions: {
        chart: {
          height: 10,
          width: 10,
          type: "radialBar",
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#ffffff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
            },
            track: {
              background: "#f3f3f3",
              strokeWidth: "80%",
              margin: 0,
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -5,
                show: true,
                color: "#888",
                fontSize: "10px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: 3,
                color: "#000",
                fontSize: "12px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: ["solid"],
          colors: ["#1da8d5"],
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Progress"],
        fontSize: "10px",
      },
      options: {
        series: [
          {
            name: "Series 1",
            data: [
              {
                x: "W1",
                y: 22,
              },
              {
                x: "W2",
                y: 29,
              },
              {
                x: "W3",
                y: 13,
              },
              {
                x: "W4",
                y: 32,
              },
            ],
          },
          {
            name: "Series 2",
            data: [
              {
                x: "W1",
                y: 43,
              },
              {
                x: "W2",
                y: 43,
              },
              {
                x: "W3",
                y: 43,
              },
              {
                x: "W4",
                y: 43,
              },
            ],
          },
        ],
      },
      tran:false
    };
  },
  components: {
    Card,
    Badge,
    Modal,
    Input,
    Button
  },
  computed: {
    ...mapGetters({
      userDetails:"getSelectedUser",
      history: "getHistory",
      progress: "getProgress",
      heatmapdata: "getHeatMapData",
      worksheets: "getAllWorkSheet",
    }),
    ...mapAuthGetters({
      user: "getUser",
    }),
    checkModuleAvailability() {
      return this.userdetails ? true : false;
    },
  },
   methods: {
    ...mapUserActions({
      getUserHistory: "GET_HISTORY_BY_ID",
      getUserProgress: "GET_PROGRESS_BY_ID",
      getUserHeatMapData: "GET_HEAT_MAP_DATA",
      getallworksheet: "GET_ALL_WORKSHEET",

    }),
    getTodayDate() {
      return new Date();
    },
    getPercentage() {
      return [Math.round((this.progress.completedTasks / this.progress.totalNoOfTasks) * 100) || 0];
    },
    handleClick(id)
    {
      this.$router.push({ path:`/mytasks/${id}`})
      // this.getWorkSheetById(id)
    },
    calculateProgress(val1,val2){
      return [Math.round((val1/val2)*100) || 0];
    },
     shrinkText(val) {
      if (val.length > 30) return val.slice(0, 30) + "..";
      else return val;
    },
    toggle(){
      this.tran=!this.tran
    },
    resetModuleCreation() {
      this.module = {
        name:"",
        email:"",
        designation:"",
        mobileNumber:"",
        location:""
      };
    },
    toggleEditUserDetailsModal(){
        this.editUserModal = !this.editUserModal;
      }
    },

  watch:{
    'userDetails'(val){
      console.log(val)
      console.clear();
           this.module.name=this.userDetails.name;
           this.module.designation=this.userDetails.designation;
           this.module.email=this.userDetails.email;
           this.module.mobileNumber=this.userDetails.mobileNumber;
           this.module.location=this.userDetails.location;
    }
  },
  mounted() {
    setTimeout(() => {
      this.getallworksheet(this.user.userId);
      this.getUserHistory(this.user.userId);
      this.getUserProgress(this.user.userId);
      this.getUserHeatMapData(this.user.userId);
      (this.completed = this.progress.completedTasks),
      (this.total = this.progress.totalNoOfTasks);
    }, 1000);
  },

}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/color.scss";
@import "../../assets/scss/font.scss";
@import "../../assets/scss/field.scss";
.fa-user-pen,.module-card{
  cursor:pointer;
}
.dashboard-card{
    background: #FFFFFF;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
    border-radius: 7px;
    height:fit-content;
}
.profile{
    height:15vh;
}
.img-circle{
    height:inherit(80%);
    & img{
        height:80px;
        width:80px;
    }
}
.heading{
    font-weight: $font-weight-bold;
    font-size: $font-size-xl;
    text-transform: capitalize;
}
.sub-heading{
    font-weight: $font-weight-bold;
    font-size: $font-size-lg;
    text-transform: capitalize;
}
.normal-text{
    font-weight: $font-weight-normal-2;
    font-size: $font-size-md;
}
.fade-text{
    font-weight: $font-weight-normal-1;
    font-size: $font-size-md;
    color:$light-500;
    text-transform: capitalize;
}
p{
    margin:0px;
}
.worksheet{
    & .content-card{
    overflow:scroll;
    }
  & .content-card::-webkit-scrollbar {
  background: none;
  width: 0px;
  height:5px;
    }
  & .content-card::-webkit-scrollbar-thumb {
  background-color: $light-300;
  border-radius: $field-border-radius;
  }
}
// .heat-map{
//     height:25vh;
// }
.activity{
  & .content-card{
    height:200px;
    overflow:scroll;
    }
  & .content-card::-webkit-scrollbar {
  background: none;
  width: 5px;
  height:0px;
    }
  & .content-card::-webkit-scrollbar-thumb {
  background-color: $light-300;
  border-radius: $field-border-radius;
  }
  
}
.content-card{
    background-color: #F6F6F6;
    height:max-content;
    border-radius: 7px;
}


.worksheet-title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;

    text-overflow: ellipsis;
    display :block;
    width: 100px;
    overflow: hidden;     
    white-space: nowrap;
}
.reporter-label {
  font-size: $font-size-sm;
  color: $badger-orange;
  font-weight: $font-weight-bold;
  margin: 0px;
}
.reporter-title {
  font-size: $font-size-sm;
  color: $light-500;
  font-weight: $font-weight-bold;
  margin: 0px;
  cursor:pointer;
}
.chart-area {
  width: 150px;
  height: 100px;
}
.module-card{
  height:100%;
}
.rounded-circle{
  background-color: rgb(238, 238, 238);
}
@media only screen and (max-width: 600px) {
  .normal-text{
    font-weight: $font-weight-normal-1;
    font-size: $font-size-sm;
}
.fade-text{
    font-weight: $font-weight-normal-1;
    font-size: $font-size-xs;
}

}
</style>